import classNames from 'classnames';
import React from 'react';

/**
 * @typedef AccordionSectionProps
 * @property {boolean} isOpen
 * @property {string} label
 * @property {import('react').MouseEventHandler} onClick
  */
/** @type {import('~/types/React').ReactFC<AccordionSectionProps>} */
const AccordionSection = ({ children, isOpen, label, onClick, ...rest }) => (
	<div {...rest} className={classNames(rest.className, 'accordion-section')}>
		<div className="headline" onClick={onClick}>
			<b>{label}</b>
			<div className={classNames('arrow-box', { open: isOpen })}>
				<span />
			</div>
		</div>
		<div className={classNames('children-container', { closed: !isOpen })}>{children}</div>
	</div>
);

export default AccordionSection;
